import {
  Autocomplete,
  Box,
  Button,
  Grid,
  Paper,
  TextField,
  Typography,
   MenuItem,
} from "@mui/material";
import { useEffect, useState } from "react";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

import { styled } from "@mui/material/styles";
import dayjs from "dayjs";
import Swal from "sweetalert2";
import axios from "../../../utils/axios";

import FdrCreateModal from "./FdrCreateModal";
import FdrViewModal from "./FdrViewModal";
import { Link } from "react-router-dom";
import DatasetIcon from '@mui/icons-material/Dataset';

// ---------- Styled Table ----------

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
   
    border: "1px solid #dad7d7",
    backgroundColor: "#A7C7E7",
    color: theme.palette.common.black,
    textAlign: "center",
    padding: 0,
    fontWeight: 600,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 12,
    textAlign: "center",
    border: "1px solid #dad7d7",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:hover": {
    backgroundColor: "#becbd8ff",
  },
}));


const FdrAccountList = () => {
  const [rows, setRows] = useState([]);

  // Modal state
  const [openModal, setOpenModal] = useState(false);
  const handleOpen = () => setOpenModal(true);
  const handleClose = () => setOpenModal(false);
  const [banks, setBanks] = useState([]);
  const [branches, setBranches] = useState([]);

const [formData, setFormData] = useState({
  bankName: null,
  branch: null,
  fdrNumber: "",
  status: "",
   dateType: "",
  dateFrom: "",
  dateTo: ""
});

const [debounceTimer, setDebounceTimer] = useState(null);
const statusOptions = [
  "ACTIVE",
  "CLOSED",
  "PREMATURED",
  "RENEWED",
  "HOLD",
  "CAPITALIZED"
];
const [openViewModal, setOpenViewModal] = useState(false);
const [selectedRow, setSelectedRow] = useState(null);

const handleOpenView = (row) => {
  setSelectedRow(row);
  setOpenViewModal(true);
};

const handleCloseView = () => {
  setOpenViewModal(false);
  setSelectedRow(null);
};

  // ================= FETCH FDR LIST =================
  useEffect(() => {
    fetchFdrList();
  }, []);

  useEffect(() => {
  axios
    .get("/bank/get-all-bank-names")
    .then((res) => {
      if (res.data.success) {
        setBanks(res.data.payload);
      }
    })
    .catch(() => Swal.fire("Error", "Failed to load banks", "error"));
}, []);

useEffect(() => {

  if (debounceTimer) {
    clearTimeout(debounceTimer);
  }

  const timer = setTimeout(() => {
    searchFdrList();
  }, 600);

  setDebounceTimer(timer);

  return () => clearTimeout(timer);

}, [formData]);


  const fetchFdrList = async () => {
    try {

      const res = await axios.get("/fdr/list");

      if (res.data.success) {
        setRows(res.data.payload);
      }

    } catch (error) {
      console.error("FDR list fetch error:", error);
      Swal.fire("Error", "Failed to load FDR list", "error");
    }
  };

  const handleBankChange = async (event, value) => {

  setFormData({
    bankName: value,
    branch: null,
    fdrNumber: formData.fdrNumber,
    status: formData.status
  });

  setBranches([]);

  if (value) {
    try {

      const res = await axios.post("/bank/get-all-banks-by-name", {
        bankName: value.bankName
      });

      if (res.data.success) {
        setBranches(res.data.payload);
      }

    } catch {
      Swal.fire("Error", "Failed to load branches", "error");
    }
  }
};

const handleBranchChange = (event, value) => {

  setFormData({
    ...formData,
    branch: value
  });

};
const handleFdrChange = (e) => {

  setFormData({
    ...formData,
    fdrNumber: e.target.value
  });

};
const handleStatusChange = (event) => {
  setFormData({
    ...formData,
    status: event.target.value
  });
};

const handleDateTypeChange = (e) => {
  setFormData({
    ...formData,
    dateType: e.target.value,
    dateFrom: "",
    dateTo: ""
  });
};

const handleDateFromChange = (e) => {
  setFormData({
    ...formData,
    dateFrom: e.target.value
  });
};

const handleDateToChange = (e) => {
  setFormData({
    ...formData,
    dateTo: e.target.value
  });
};

const searchFdrList = async () => {

  try {

    let params = {
      bankName: formData.bankName?.bankName || "",
      fdrNumber: formData.fdrNumber || "",
      branch: formData.branch?.routingNo || "",
      status: formData.status || "",
      startDateFrom: "",
      startDateTo: "",
      maturityDateFrom: "",
      maturityDateTo: ""
    };

    // If Starting Date selected
    if (formData.dateType === "START_DATE") {
      params.startDateFrom = formData.dateFrom;
      params.startDateTo = formData.dateTo;
    }

    // If Maturity Date selected
    if (formData.dateType === "MATURITY_DATE") {
      params.maturityDateFrom = formData.dateFrom;
      params.maturityDateTo = formData.dateTo;
    }

    const res = await axios.get("/fdr/list", { params });

    if (res.data.success) {
      setRows(res.data.payload);
    }

  } catch (error) {
    console.error(error);
  }

};
const handleReset = () => {

  setFormData({
    bankName: null,
    branch: null,
    fdrNumber: ""
  });

  setBranches([]);

  // reload full list
  fetchFdrList();
};

const totalRow = rows.find((row) => row.fdrNumber === "TOTAL");
const dataRows = rows.filter((row) => row.fdrNumber !== "TOTAL");

const handleDownloadExcel = async () => {
  try {
    let params = {
      bankId: formData.bankName?.id || "",
      fdrNumber: formData.fdrNumber || "",
      branch: formData.branch?.routingNo || "",
      status: formData.status || "",
      interestBasis: "", // add if needed
      startDateFrom: "",
      startDateTo: "",
      maturityDateFrom: "",
      maturityDateTo: ""
    };

    // Date logic (same as search)
    if (formData.dateType === "START_DATE") {
      params.startDateFrom = formData.dateFrom;
      params.startDateTo = formData.dateTo;
    }

    if (formData.dateType === "MATURITY_DATE") {
      params.maturityDateFrom = formData.dateFrom;
      params.maturityDateTo = formData.dateTo;
    }

    const res = await axios.get(
      "/fdr/list/download",
      {
        params,
        responseType: "blob", // 🔥 IMPORTANT
      }
    );

    // Create file download
    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement("a");

    link.href = url;
    link.setAttribute("download", "FDR_List.xlsx"); // file name
    document.body.appendChild(link);
    link.click();

    link.remove();
  } catch (error) {
    console.error(error);
    Swal.fire("Error", "Failed to download Excel", "error");
  }
};

const formatKotiStyle = (num) => {
  if (num === null || num === undefined) return "0.00";

  const fixed = Number(num).toFixed(2);
  const [intPart, decPart] = fixed.split(".");

  // 👉 If less than 1 crore → use standard Indian format
  if (intPart.length <= 8) {
    return Number(num).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }

  // 👉 Koti-style for large numbers
  const lastThree = intPart.slice(-3);
  let rest = intPart.slice(0, -3);

  const groups = [];

  while (rest.length > 3) {
    groups.unshift(rest.slice(-2));
    rest = rest.slice(0, -2);
  }

  // keep leftmost as full (Koti block)
  groups.unshift(rest);

  return `${groups.join(",")},${lastThree}.${decPart}`;
};
  return (
    <Box p={1}>

      {/* Header */}
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >

        <Typography variant="h6">
          FDR Account List
        </Typography>

     <Box display="flex" gap={2} flexWrap="wrap">

                <Button
                variant="contained"
                color="primary"
                component={Link}
                to="/app/account/fdrDashboard"
              >
                Dashboard
              </Button>


        <Button
          variant="contained"
          color="primary"
          onClick={handleOpen}
        >
          Add FDR
        </Button>
           {/* <Button
          variant="contained"
          color="success"
          onClick={handleDownloadExcel}
        >
          Download Excel
        </Button> */}

          <Button variant="contained" color="primary" title="Download in Excel" onClick={handleDownloadExcel}>
              <DatasetIcon/>
           </Button>


           <Button
      variant="contained"
      // color="error"
      onClick={handleReset}
      // sx={{ height: "56px", minWidth: "10px" }}
      // fullWidth
    >
      Reset
    </Button>


      </Box>
      </Box>

<Grid
  container
  spacing={2}
  mb={2}
  sx={{
    flexWrap: "wrap",
  }}
>

  {[
    <Autocomplete
      options={banks}
      value={formData.bankName}
      onChange={handleBankChange}
      getOptionLabel={(option) => option.bankName || ""}
      renderInput={(params) => (
        <TextField {...params} label="Bank Name" fullWidth />
      )}
    />,

    <Autocomplete
      options={branches}
      value={formData.branch}
      onChange={handleBranchChange}
      disabled={!formData.bankName}
      getOptionLabel={(option) =>
        option.branchName
          ? `${option.branchName} - ${option.routingNo}`
          : ""
      }
      renderInput={(params) => (
        <TextField {...params} label="Branch Name" fullWidth />
      )}
    />,

    <TextField
      label="FDR Number"
      value={formData.fdrNumber}
      onChange={handleFdrChange}
      fullWidth
    />,

    <TextField
      select
      label="Status"
      value={formData.status}
      onChange={handleStatusChange}
      fullWidth
    >
      <MenuItem value="">All</MenuItem>
      {statusOptions.map((status) => (
        <MenuItem key={status} value={status}>
          {status}
        </MenuItem>
      ))}
    </TextField>,

    <TextField
      select
      label="Date Type"
      value={formData.dateType}
      onChange={handleDateTypeChange}
      fullWidth
    >
      <MenuItem value="">None</MenuItem>
      <MenuItem value="START_DATE">Starting Date</MenuItem>
      <MenuItem value="MATURITY_DATE">Maturity Date</MenuItem>
    </TextField>,

    <TextField
      type="date"
      label="From Date"
      InputLabelProps={{ shrink: true }}
      value={formData.dateFrom}
      onChange={handleDateFromChange}
      disabled={!formData.dateType}
      fullWidth
    />,

    <TextField
      type="date"
      label="To Date"
      InputLabelProps={{ shrink: true }}
      value={formData.dateTo}
      onChange={handleDateToChange}
      disabled={!formData.dateType}
      fullWidth
    />,

 
  ].map((component, index) => (
    <Grid
      item
      key={index}
      xs={12}
      sm={6}
      md
      sx={{ minWidth: 160 }}
    >
      {component}
    </Grid>
  ))}
</Grid>

      {/* ================= TABLE ================= */}
 <TableContainer
  component={Paper}
  sx={{
    maxHeight: 480,
 
  }}
>

        <Table size="small"  stickyHeader size="small">
          <TableHead style={{ stickyHeader: "true", backgroundColor: "#A7C7E7" }}>
            <TableRow>
              <StyledTableCell >SL</StyledTableCell>
              <StyledTableCell>Start Date</StyledTableCell>
              <StyledTableCell>Maturity Date</StyledTableCell>
              <StyledTableCell>Days Left</StyledTableCell>
              <StyledTableCell>Bank</StyledTableCell>
              <StyledTableCell>Branch</StyledTableCell>
              <StyledTableCell>A/C Number</StyledTableCell>
              <StyledTableCell>Amount</StyledTableCell> 
              <StyledTableCell>Rate</StyledTableCell>
              {/* <StyledTableCell>Basis</StyledTableCell> */}
              <StyledTableCell>Excise Duty</StyledTableCell>
              <StyledTableCell>Tax Amount</StyledTableCell>
              <StyledTableCell>Tax Rate</StyledTableCell>
              <StyledTableCell>Bank Charge</StyledTableCell>
              <StyledTableCell>Gross Interest</StyledTableCell>
              <StyledTableCell>Net Interest</StyledTableCell>
              <StyledTableCell>Status</StyledTableCell>
              <StyledTableCell>Action</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>

            {dataRows.map((row, index) => (
              

              <StyledTableRow key={row.id} style={{  backgroundColor: row.maturityStatus === "RED" ? "#f8afaf" : row.maturityStatus === "GREEN" ? "#c6ecc7"  : row.maturityStatus === "YELLOW" ? "#f0dc9b" : "inherit" }}>

                <StyledTableCell>
                  {index + 1}
                </StyledTableCell>

                <StyledTableCell>
                  {dayjs(row.startDate).format("DD-MM-YYYY")}
                </StyledTableCell>

                <StyledTableCell>
                  {dayjs(row.maturityDate).format("DD-MM-YYYY")}
                </StyledTableCell>
                 <StyledTableCell>
                  {row.remainingdays}
                </StyledTableCell>

                <StyledTableCell>
                  {row.bankName}
                </StyledTableCell>

                <StyledTableCell>
                  {row.branchName} ({row.routingNo})
                </StyledTableCell>

                <StyledTableCell>
                  {row.fdrNumber}
                </StyledTableCell>

              <StyledTableCell>
                {row.principalAmount
                  ? formatKotiStyle(row.principalAmount)
                  : "0"}
              </StyledTableCell>

                   <StyledTableCell>
                    {row.interestRate} ({
                      row.interestBasis === "MONTHLY"
                        ? "M"
                        : row.interestBasis === "DAILY"
                        ? "D"
                        : row.interestBasis === "YEARLY"
                        ? "Y"
                        : ""
                    })
                  </StyledTableCell>

                <StyledTableCell>
                  {row.exciseDuty
                  ? formatKotiStyle(row.exciseDuty)
                  : "0"}
                </StyledTableCell>

                <StyledTableCell>
                  {row.taxamount
                  ? formatKotiStyle(row.taxamount)
                  : "0"}
                </StyledTableCell>

                  <StyledTableCell>
                   {row.taxRate
                  ? formatKotiStyle(row.taxRate)
                  : "0"}
                </StyledTableCell>

                 <StyledTableCell>
                   {row.bank_charge
                  ? formatKotiStyle(row.bank_charge)
                  : "0"}
                </StyledTableCell>

                <StyledTableCell>
                  {row.gross_interest
                  ? formatKotiStyle(row.gross_interest)
                  : "0"}
                </StyledTableCell>

                <StyledTableCell>
                  {row.net_interest
                  ? formatKotiStyle(row.net_interest)
                  : "0"}
                </StyledTableCell>

                <StyledTableCell>
                  {row.status}
                </StyledTableCell>
                <StyledTableCell>
              <Button
                variant="outlined"
                size="small"
                onClick={() => handleOpenView(row)}
                sx={{ borderColor: "#0d7ceb", color: "#0d7ceb", "&:hover": { backgroundColor: "#0d7ceb", color: "white" } }}
             
                
              >
                View
              </Button>
            </StyledTableCell>

              </StyledTableRow>

            ))}


              {/* Grand Total */}
              {totalRow && (
  <StyledTableRow
    sx={{
      position: "sticky",
      bottom: 0,
      backgroundColor: "#e6eef7 !important",
      zIndex: 2,
      fontWeight: "bold",
    }}
  >
    <StyledTableCell></StyledTableCell>
    <StyledTableCell><b>Total</b></StyledTableCell>
    
    <StyledTableCell></StyledTableCell>
    <StyledTableCell></StyledTableCell>

    <StyledTableCell></StyledTableCell>
    <StyledTableCell></StyledTableCell>

    <StyledTableCell></StyledTableCell>

    {/* Principal Amount */}
    <StyledTableCell>
      <b>
        {formatKotiStyle(totalRow.principalAmount || 0)}
      </b>
    </StyledTableCell>

    <StyledTableCell></StyledTableCell>

    {/* Excise Duty */}
    <StyledTableCell>
      <b>
        {Number(totalRow.exciseDuty || 0).toLocaleString("en-IN")}
      </b>
    </StyledTableCell>

    {/* Tax Amount */}
    <StyledTableCell>
      <b>
        {Number(totalRow.taxamount || 0).toLocaleString("en-IN")}
      </b>
    </StyledTableCell>

    {/* Tax Rate (optional skip or show) */}
    <StyledTableCell></StyledTableCell>

    {/* Bank Charge */}
    <StyledTableCell>
      <b>
        {formatKotiStyle(totalRow.bank_charge || 0)}
      </b>
    </StyledTableCell>

    {/* Gross Interest */}
    <StyledTableCell>
      <b>
        {formatKotiStyle(totalRow.gross_interest || 0)}
      </b>
    </StyledTableCell>

    {/* Net Interest */}
    <StyledTableCell>
      <b>
        {formatKotiStyle(totalRow.net_interest || 0)}
      </b>
    </StyledTableCell>

    <StyledTableCell></StyledTableCell>
    <StyledTableCell></StyledTableCell>
  </StyledTableRow>
)}
          </TableBody>

        </Table>

      </TableContainer>


      {/* ================= MODAL ================= */}
      <FdrCreateModal
        open={openModal}
        handleClose={handleClose}
        refreshList={fetchFdrList}
      />

      <FdrViewModal
  open={openViewModal}
  handleClose={handleCloseView}
  data={selectedRow}
  refreshList={fetchFdrList}

/>

    </Box>
  );
};

export default FdrAccountList;